import React, { useState } from 'react';

import { MenuItem, Popover } from '@material-ui/core';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import styled, { css } from 'styled-components';
import { StyledGrid, StyledTooltip, StyledTypography, StyledBox } from 'styles/common';

import { getColorFromKey } from 'constants/helper';
import { DotsIcon, ArchiveIcon, DuplicateIcon } from 'constants/icons';
import theme from 'constants/theme';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Typography13 } from 'uiToolkit/Typography';

const TAB_TYPES = {
  ARCHIVED: 'ARCHIVED',
  ACTIVE: 'ACTIVE',
};

const OptionsComponent = ({ currentTab, template, handleArchiveClick, handleDuplicateClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const onDuplicateClick = (e) => {
    e.stopPropagation();

    handleDuplicateClick(template.id);
  };

  const onArchiveClick = (e) => {
    e.stopPropagation();
    const ISARCHIVE = currentTab === TAB_TYPES.ACTIVE;

    handleArchiveClick(template.id, ISARCHIVE);
  };

  return (
    <>
      <FullWidthBox flexcontainer justifycontent="flex-end" alignitems="center">
        <StyledCircularOutlineIcon onClick={handleClick} color="primary" icon={StyledDotsIcon} />
      </FullWidthBox>
      <Popover
        disablePortal
        id="objective-tag-actions"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ marginTop: '0.5rem' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {currentTab === TAB_TYPES.ACTIVE && (
          <StyledMenuItem onClick={onDuplicateClick}>
            <DuplicateIcon size="fixed12px" color={theme.palette.icons.blackv1} />
            <Typography13 color={theme.palette.text.blackv1} leftGutter={2.25}>
              Duplicate
            </Typography13>
          </StyledMenuItem>
        )}
        <StyledMenuItem $materialIcon onClick={onArchiveClick}>
          {currentTab === TAB_TYPES.ACTIVE ? <ArchiveIcon leftGutter={-0.25} /> : <UnarchiveIcon leftGutter={-0.25} />}

          <Typography13 color={theme.palette.text.blackv1} leftGutter={2}>
            {currentTab === TAB_TYPES.ACTIVE ? 'Archive' : 'Unarchive'}
          </Typography13>
        </StyledMenuItem>
      </Popover>
    </>
  );
};

const TemplateRow = ({ currentTab, template, handleClick, handleArchiveClick, handleDuplicateClick }) => (
  <RowGrid alignItems="center" padding="0.5rem 0rem" container onClick={() => handleClick(template.id)}>
    <StyledGrid item xs={7} paddingRight="1rem">
      <StyledTooltip title={template.name}>
        <StyledTypography truncate>{template.name}</StyledTypography>
      </StyledTooltip>
    </StyledGrid>
    <StyledGrid item xs={3}>
      {template.createdByEmployee}
    </StyledGrid>
    <StyledGrid item xs={2}>
      <FlexContainer>
        {template.questionCount}
        <FullWidthBox flexcontainer justifycontent="flex-end" alignitems="center">
          {handleDuplicateClick && handleArchiveClick && (
            <OptionsComponent
              currentTab={currentTab}
              template={template}
              handleArchiveClick={handleArchiveClick}
              handleDuplicateClick={handleDuplicateClick}
            />
          )}
          <StyledCircularOutlineIcon color="primary" />
        </FullWidthBox>
      </FlexContainer>
    </StyledGrid>
  </RowGrid>
);

export default TemplateRow;

const StyledCircularOutlineIcon = styled(CircularOutlineIcon)`
  visibility: hidden;
  margin-left: 1.5rem;
`;

const RowGrid = styled(StyledGrid)`
  &:hover {
    background: ${(props) => props.theme.palette.background.blue.light.v2};
    cursor: pointer;
  }
  padding: 1rem 1.5rem;
  &:hover ${StyledCircularOutlineIcon} {
    visibility: visible;
  }
  border-bottom: 1px solid ${getColorFromKey('lightGrey')};
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const StyledDotsIcon = styled(DotsIcon)`
  width: 13px;
  margin-top: 1px;
`;

const FullWidthBox = styled(StyledBox)`
  width: 100%;
`;

const StyledMenuItem = styled(MenuItem)`
  padding-right: 30px;
  ${(props) =>
    props.$materialIcon &&
    css`
      svg {
        font-size: 1rem;
        width: 16px;
        height: 16px;
        color: ${(props) => props.theme.palette.icons.black.v1};
      }
    `}
`;
